import React from 'react';
import { trackEvent } from '../utils/bridge.js';

export const EXPIRED_ACCOUNT_LOGIN_MESSAGE = 'Your account has expired. To reactivate your account please contact the WhatsApp support team. Tap on the WhatsApp button below.';
const EXPIRED_ACCOUNT_WHATSAPP_TEXT = 'Hi, my account has expired, how can I reactivate my account';
const EXPIRED_ACCOUNT_WHATSAPP_URL = `https://wa.me/447456722140?text=${encodeURIComponent(EXPIRED_ACCOUNT_WHATSAPP_TEXT)}`;

export default function ExpiredAccountModal({ show, onClose }) {
    if (!show) return null

    return (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/70 p-4" role="dialog" aria-modal="true" aria-label="Expired account notice">
            <div className="w-full max-w-md rounded-2xl bg-white p-6 text-center text-black shadow-2xl">
                <h2 className="mb-3 text-2xl font-bold">Account expired</h2>
                <p className="mb-5 text-base leading-relaxed">{EXPIRED_ACCOUNT_LOGIN_MESSAGE}</p>
                <a
                    className="mb-3 block w-full rounded-full bg-[#25D366] px-5 py-3 font-bold text-white no-underline hover:bg-[#1ebc59]"
                    href={EXPIRED_ACCOUNT_WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackEvent('expired_account_whatsapp_clicked')}
                >
                    WhatsApp Support
                </a>
                <button className="w-full rounded-full border border-gray-300 px-5 py-2 font-semibold text-gray-700" type="button" onClick={onClose}>Close</button>
            </div>
        </div>
    )
}
